import axios from 'axios'
import { useQuery, useQueryClient, useMutation } from 'react-query'

export const globalEventGuestLinkFetcher = async (body) => {
    const { data } = await axios.post('/guestlink', body)
    const parsedData = JSON.parse(data.jsonString)
    return parsedData.guests
}

export const useFetchGuestLink = (eventIDvalue) => {
    var body = {"eventid": eventIDvalue}
    return useQuery(
        ['guestlink', eventIDvalue],
        () => globalEventGuestLinkFetcher(body),
        {}
    )
}

export const usePutGuestLink = () => {
    const queryClient = useQueryClient()
    //console.log(" useputparticipant on query page")

    return useMutation((body: any) =>
        axios.put(`guestlink`, body), {
        onSuccess: () => {
            queryClient.invalidateQueries(['guestlink'])
        }
    })
}
//
// export const usePutPurchaserLink = (eventid: number, participantid: number) => {
//     // requires eventid: any, purchaserid: any
//     const queryClient = useQueryClient()
//
//     const body = {eventid: eventid, participantid: participantid}
//     axios.put(`purchaserlink`, body).then(response => {
//         queryClient.invalidateQueries(['purchaserlink'])
//     })
// }
export const usePutGuestUnLink = (eventid: number, participantid: number) => {
    // requires eventid: any, purchaserid: any
    const queryClient = useQueryClient()

    const body = {eventid: eventid, participantid: participantid}
    axios.put(`guestunlink`, body).then(response => {
        queryClient.invalidateQueries(['guestlink'])
    })
}

export const usePutGuestAutoLink = () => {
    const queryClient = useQueryClient()

    return useMutation((body: any) =>
        axios.post(`guestlinkauto`, body), {
        onSuccess: () => {
            queryClient.invalidateQueries(['linkingguest'])
        }
    })
}